import React from 'react';

import {IFooterNavigationProps} from './IFooterNavigation';

import styles from './FooterNavigation.module.scss';

const FooterNavigation = ({children}: IFooterNavigationProps) => {
	return <nav className={styles['footer__navigation']}>{children}</nav>;
};

export default FooterNavigation;
